<template>
  <div class="report-card">
    <Card class="mb-5 transition-all duration-300 ease-in-out position-relative"  :class="{ 'scale-105 shadow-lg': selected, 'shadow': !selected }" :style="{'border': selected ? '3px  solid '+natureColor : '' }">
      <div class="card-xl-stretch ">
        <a class="d-block position-relative w-full h-7px" :style="{'border-top-left-radius': '8px', 'border-top-right-radius': '8px', 'background-color':natureColor}">
          <div class="triangle" v-if="selected" :style="{ 'border-color':natureColor + ' transparent transparent transparent'}">
          </div>
        </a>

        <div class="card-header px-5">
          <div class="card-title p-0">
            <h3 class="card-title align-items-start flex-column" >
              <div  class="cursor-pointer" @click.prevent="handleClick">
                <span class="card-label fw-bolder text-dark" :title="projectData.title">{{ subText(projectData.title, 35) }}</span>
                <span class="fs-4"> <img src="/assets/media/icons/need_review.png" class="h-20px text-primary align-self-center" :title="$t('tasks.label.remainReview')"> {{projectData.total_task_remaining_review}} </span>
              </div>
              <span class="text-primary mt-1 fw-bold fs-7"><span class="fw-light" :style="{'color': natureColor}">{{ projectData?.category }}</span> <span class="text-primary" v-if="projectData?.reference"> | {{ projectData?.reference }}</span></span>
            </h3>
          </div>
          <div class="card-toolbar">
             <div class="accordion-item border-0"> 
              <div @click.prevent="toggleContactAccordion" >
                <div class="d-flex justify-content-end flex-wrap">
                  <div v-for="(contact, idx) in projectData.contact" :key="contact?.id"  v-show="idx < 1" class="text-primary fw-bold bg-light-primary px-2 py-1 rounded mx-1 mb-1">
                    {{contact.contact_name}} <span class="badge badge-primary">{{contact.status_name}}</span>
                  </div>
                  <div v-if="(projectData.contact && projectData.contact.length > 1)" class="text-muted px-2 py-1 mx-1 mb-1">
                    <span v-if="!showAccordion"> +{{ projectData.contact.length - 1 }} <i class="fa fa-angle-down"></i></span>
                    <span v-else> -{{ projectData.contact.length - 1 }} <i class="fa fa-angle-up"></i></span>
                  </div>
                </div>
              </div>

              <div v-show="projectData.contact.length > 1" :id="'contact_accordion_body'+projectData.id" class="accordion-collapse collapse" :class="{ 'show border-bottom': showAccordion }">
                <div class="accordion-body d-flex justify-content-end flex-wrap m-0 p-0">
                  <div v-for="(contact, idx) in projectData.contact" :key="contact?.id" v-show="idx >= 1"class="text-primary fw-bold bg-light-primary px-2 py-1 rounded mx-1 mb-1">
                    {{contact.contact_name}} <span class="badge badge-primary">{{contact.status_name}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="m-5 cursor-pointer" @click.prevent="handleClick">
          <div class="d-flex justify-content-between align-items-center">
            <div class="bg-white text-primary border border-gray-300 fw-bold p-3 w-25" style="border-radius: 5px;">
              <span class="badge badge-square border border-gray-300 p-2 badge-light-primary me-2">{{projectData?.completedSteps}}/{{projectData?.totalStep}}</span>
              {{$t('reports.steps')}}
            </div>
            <div class="d-flex align-items-center text-primary bg-white border border-gray-300 fw-bold p-3 " style="border-radius: 5px; width: 30%">
              <span class="badge badge-square border border-gray-300 p-2 badge-light-primary me-2">{{projectData?.taskDone}}/{{projectData?.totalTask}}</span>
              {{$t('reports.tasks')}}
              <span class="badge badge-square border border-gray-300 p-2 badge-light-primary ms-2" :title="$t('tasks.label.reviewedBeReview')">
                <img src="/assets/media/tasks/validate.png" class="h-15px me-2"> {{projectData.total_task_reviewed}}/{{projectData.total_task_need_review}}
              </span>
            </div>
            <div class="d-flex justify-content-center align-items-center">
              <span :class=" 'me-3 fs-4 text-' + projectData?.status?.color">{{ projectData?.status?.[locale] }}</span>
              <div class="circle-progress-wrapper">
                <circle-progress
                    :size="40"
                    empty-color="#E7E6E6"
                    :border-width="5"
                    :border-bg-width="5"
                    :show-percent="false"
                    :percent="projectData?.progress"
                    :fill-color="color"
                />
                <span class="progress-unit">{{ projectData?.progress }}%</span>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer p-5" v-if="projectData.manager">
          <div  class="d-flex justify-content-between mb-2">
            <div>
              <span class="badge badge-primary fs-5 me-2" v-for="manager in projectData.manager">{{manager}}</span>
            </div>
            <div class="text-primary fw-bold fs-5">{{ projectData?.usersAssignedCount + ' ' + $t('projects.label.users',projectData?.usersAssignedCount) }}</div>
          </div>
        </div>

      </div>
      <div class="card-footer p-5" v-if="projectData?.history">
        <LastUpdate :id="'folder'+id" :history="projectData?.history"/>
      </div>
      <div class="d-flex gap-2 position-absolute bottom-0 translate-middle-y mb-n18 ">
        <template v-if="Object.keys(projectReactsGrouped).length">
          <FolderCardReactResume
              v-for="(reacts, emoji) in projectReactsGrouped"
              :key="emoji"
              :folder-id="projectData.id"
              :emoji="emoji"
              :reacts="reacts"
              :total="reacts.length"
              @callback="$emit('reloadData')"
          />
        </template>
        <FolderCardQuickComment
            v-if="projectComments.length"
            with-total
            :addComment="toggleQuickCommentModal"
            :total="projectComments.length"
            :classes="'text-primary'"
        />
        <div class="d-flex gap-2 report-comment-action">
          <FolderCardQuickReact :folder="projectData" @callback="$emit('reloadData')" />
          <FolderCardQuickComment  v-if="!projectComments.length" :addComment="toggleQuickCommentModal" />
        </div>
      </div>
    </Card>
  </div>
  <QuickCommentModal
      :id="'quick-folder-comment-modal-'+projectData.id"
      :form="{...quickCommentData, id: projectData.id, oldComments: projectComments}"
      @callback="$emit('reloadData')"/>
</template>

<script setup>
    import {computed, ref, defineProps} from "vue";
    import Card from '@/components/Card.vue';
    import "vue3-circle-progress/dist/circle-progress.css";
    import CircleProgress from "vue3-circle-progress";
    import { useRouter } from "vue-router";
    import { useLocales } from "@/composables/locales";
    import {getInitials, subText} from "@/mixins/Helpers";
    import LastUpdate from "@/Modules/Projects/components/LastUpdate.vue";
    import FolderCardQuickComment from "@/Modules/Projects/views/Reports/components/FolderCardQuickComment.vue";
    import FolderCardReactResume from "@/Modules/Projects/views/Reports/components/FolderCardReactResume.vue";
    import FolderCardQuickReact from "@/Modules/Projects/views/Reports/components/FolderCardQuickReact.vue";
    import QuickCommentModal from "@/Modules/Projects/views/Reports/components/QuickCommentModal.vue";

    const emit = defineEmits(['reloadData'])

    const props = defineProps({
        project: {
            type: Object,
            default: {
                id: 1,
                title: "",
                progress: "",
                status_formatted: {
                    color: "",
                    fr: ""
                }
            }
        },
        handleProjectSelected: {
            type: Function,
            default: () => {}
        },
        selected: {
            type: Boolean,
            default: false
        },
        id: {
            type: [String, Number],
            default: "id"
        }
    })

    const {locale} = useLocales()
    const router = useRouter()
    const projectData = ref(props.project)
    const showAccordion = ref(false)

    const quickCommentData = ref({
      id: '',
      comment: '',
    })

    const natureColor = computed(() => {
        return projectData.value.color ?? $getCssVariable('--bs-primary')
    })

    const color = computed(() => {
        switch (projectData?.value?.status?.color) {
            case 'success':
            return $getCssVariable('--bs-success')
            case 'warning':
            return $getCssVariable('--bs-warning')
            case 'primary':
            return $getCssVariable('--bs-primary')
            case 'danger':
            return $getCssVariable('--bs-danger')
            default:
            return $getCssVariable('--bs-primary')
        }
    })
    const projectReacts = computed(() => props.project.commentsList?.EMOJI || [])

    const projectReactsGrouped = computed(() => {
      if (projectReacts.value.length) {
        return projectReacts.value.reduce((acc, react) => {
          const key = react.comment
          if (!acc[key]) {
            acc[key] = []
          }
          acc[key].push(react)
          return acc
        }, {})
      }
      return {}
    })

    const projectComments = computed(() => {
      if(props.project && props.project.commentsList) {
        return props.project.commentsList?.TEXT || []
      }
      return []
    })

    function toggleContactAccordion() {
      showAccordion.value = !showAccordion.value;
    }

    const $getCssVariable = (variable) => window.getComputedStyle(document.documentElement).getPropertyValue(variable).trim()

    const handleClick = () => {
        props.handleProjectSelected(props.project?.id)
    }

    const getModelElement = () => {
        let attr = ['title', 'name', 'comment']
        let existKey = attr.find(key => props.project?.history?.model?.[key] !== undefined)
        return props.task?.history?.model[existKey];
    }

    function toggleQuickCommentModal() {
      $('#quick-folder-comment-modal-'+projectData.value.id).modal('toggle')
    }


     
</script>
<style scoped>
.report-card {
  padding-bottom: 20px;
}

.report-comment-action {
  opacity: 0;
  pointer-events: none;
  transform: translateY(-5px);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.report-card:hover .report-comment-action {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
}

.circle-progress-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.progress-unit {
    position: absolute;
    font-size: 10px;
}
.accordion-item{
    border: 0px !important;
}

.accordion-button:not(.collapsed) {
    color: #000 !important;
    background-color: #fff !important;
    box-shadow: inset 0 -1px 0 #fff;
}

.accordion-button{
    padding: 0px !important;
}

button:not(.collapsed)::after {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000000'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e") !important;
    transform: rotate(-180deg) !important;
}

.accordion-body{
    padding: 0px !important;
}

.back{
  background-color: var(--bs-light-primary);
  border-radius: 8px;
  padding: 10px;
  width: auto;
}

.triangle {
    position:relative;
}

.triangle {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 30px 30px 0 0;
 
}

.triangle::after {
  content: "✔";
  position: absolute;
  top: -35px;
  left: 0px;
  color: white;
  font-size: 20px;
  font-weight: bold;
}

.current-counter::after {
  content: " %"; 
}
</style>